import styled, { css } from 'styled-components';
import { defaultTheme } from "../theme";

export const CompactPaymentWrapper = /*#__PURE__*/styled('div').withConfig({ displayName: "styles__CompactPaymentWrapper", componentId: "sc-177h3sh-0" })(["display:flex;height:29px;"]);




export const IconWrapper = /*#__PURE__*/styled('span').withConfig({ displayName: "styles__IconWrapper", componentId: "sc-177h3sh-1" })(["color:", ";align-self:center;height:24px;"],
(props) => props.theme.colors.Foreground);




IconWrapper.defaultProps = {
  theme: defaultTheme };


export const DefaultWrapper = /*#__PURE__*/styled('div').withConfig({ displayName: "styles__DefaultWrapper", componentId: "sc-177h3sh-2" })(["", " color:", ";padding-left:", ";align-self:center;"],
(props) => css(props.theme.typography.Subheadline),
(props) => props.theme.colors.Foreground,
(props) => props.theme.spacers.L);



export const TightFitWrapper = /*#__PURE__*/styled(DefaultWrapper).withConfig({ displayName: "styles__TightFitWrapper", componentId: "sc-177h3sh-3" })(["font-size:16px;line-height:19px;"]);




DefaultWrapper.defaultProps = {
  theme: defaultTheme };